export default __webpack_public_path__ + "static/media/template1.e2337c30.png";